<template>
  <div class="device-key-setting-v2">
    <div class="border_title">
      {{ $t('deviceMsg.keySetting') }}
    </div>
    <div class="device-key-setting-container">
      <div class="device-key-setting-container-right">
        <div v-loading="loading">
          <div v-for="(item, index) in keyList" :key="index" class="device-key-setting-item">
            <span class="device-key-setting-item-title">
              {{ item.Desc }}
            </span>
            <div class="device-key-setting-list-box">
              <div v-for="(triggerType, i) in item.EnumList" class="device-key-setting-item-right">
                <el-popover
                  placement="left"
                  width="340"
                  trigger="click"
                  class="el-popover-custom"
                  :disabled="!!item.classSku"
                >
                  <ul class="opple-ability-ui-com-image-icon-enum_imglist">
                    <li
                      v-for="(img, i) in sceneIconList"
                      :key="i"
                      class="opple-ability-ui-com-image-icon-enum_img"
                      :class="{ active: triggerType.selectIndex === i }"
                      @click="() => handlerIconClick(triggerType, i)"
                    >
                      <img :src="img.Icon">
                    </li>
                  </ul>
                  <div slot="reference" class="planeBox-icon">
                    <div class="opple-ability-ui-com-image-icon-enum_icon">
                      <img :src="triggerType.Icon">
                      <img src="../../assets/img/edit.png" class="edit">
                    </div>
                  </div>
                </el-popover>
                <el-input
                  v-model="triggerType.keyName"
                  :placeholder="$t('deviceMsg.keyInput')"
                  style="width: 200px"
                  :disabled="!!item.classSku"
                  @input="changeInput(triggerType)"
                />
                <div class="scene_list">
                  <!-- <div v-for="(triggerType, index) in item?.EnumList" :key="index" class="scene_list_item"> -->
                  <div class="scene_list_item_header">
                    <div class="triggerType_header">
                      <span>{{ triggerType?.Name }}</span>
                      <span class="tip">{{ triggerType?.tip }}</span>
                      <span v-if="showAdd(triggerType)" class="addSence" @click="onAddSence(item,triggerType)">{{ $t('user.add') }}</span>
                    </div>
                    <div v-for="(sceneInfo, index) in triggerType.sceneList" :key="index" class="iftt_add_item">
                      <span>{{ sceneInfo.IFT_Name }}</span>
                      <div>
                        <i class="el-icon-edit iftt_edit" @click="editIftt(sceneInfo?.info)" />
                        <i class="el-icon-delete iftt_delete" @click="delIftt(sceneInfo?.info)" />
                      </div>
                    </div>
                  <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="paramSaveBlue paramSave save-btn" :class="isChange ? 'change' : 'gray'" @click="savesubmit">
            {{ $t('deviceMsg.savesubmit') }}
          </button>
        </div>
      </div>
    </div>

    <OpDialog
      class="triggerIfttt-opDialog"
      :title="$t('deviceMsg.colorCustomize')"
      :visible="showIfttDialog"
      :is-show-btn="false"
      @onClose="closeIfttDialog"
    >
      <IftttCustomSet
        v-if="showIfttDialog"
        ref="EleIftttCustomSet"
        :is-regular-triggle="true"
        :is-triggle="true"
        :is-action="true"
        :is-schedule="true"
        :is-navigate="false"
        :is-init-create-request="true"
        :is-jump-back-page="false"
        :is-need-request-triggger="false"
        :is-custom-back="true"
        :show-entry="1"
        :is-inno-trigger="true"
        :gp-no="device?.Gpno"
        @postEvent="postEvent"
        @back="closeIfttDialog"
      />
    </OpDialog>
  </div>
</template>
<script>
//按键设置组件
import { GetImageList, getSwitchKeyEventList, setSwitchKeyName } from '@/axios/IFttt.js'
import { FindTriggerAbility, FindDeviceAbilityByVDeviceId } from '@/axios/IDevice.js'
import { FindIFtttListByTrigger, Find, Create, Delete } from '@/axios/IFttt.js'
import { alertsuccess, info, alerterror } from '@/assets/js/common.js'
import { jsToUTF8 } from '@/utils/utils.js'
import IftttCustomSet from '@/page/ifttt/iftttCustomSet'
import OpDialog from './OpDialog'
const KEYSETTING = {
  smart: 1, //智能灯
  notSmart: 0, //非智能灯
  notSet: 2, //未设置
}
export default {
  components: {
    OpDialog,
    IftttCustomSet,
  },
  props: {
    device: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      KeyEventList: [],
      TriggerList: [],
      sceneIconList: [],
      loading: false,
      showIfttDialog: false, //显示场景弹窗
      keyList: [], //按键列表
      max: 1, //场景最多几条
      isChange: false
    }
  },
  computed: {
    //判断是否修改过
    // isChange() {
    //   const changeData = this.keyList.some(item => (item.EnumList || []).some(item => item.change));
    //   debugger
    //   return !!changeData;
    // },
  },
  async mounted() {
    this.getImageList()
    this.handleGpList()
  },
  methods: {
    //获取图片列表
    async getImageList() {
      try {
        const res = await GetImageList()
        this.sceneIconList = (res.Result || []).map(item => ({
          ...item,
          HIcon: `${item.FileUrl}+6`,
          Icon: `${item.FileUrl}+6`,
        }))
      } catch (e) {}
    },
    //获取已配置的按键列表
    async getKeyEventList() {
      try {
        const res = await getSwitchKeyEventList({
          vDeviceId: this.device.VDeviceId,
          type: 1,
        })
        if (res.StatusCode == 0) {
          this.KeyEventList = res?.Result || []
          this.KeyEventList.forEach(item => {
            //匹配按键 ,复制名字以及icon
            const { KeyEvent, NameId, MessageType } = item
            
            const find = this.keyList.find(info => {
              const { triggerInfo } = info
              if (triggerInfo) {
                const { PhyPosition, MsgID, DefaultValue } = triggerInfo
                return PhyPosition == NameId && MessageType == MsgID
              }
              return false
            })
            debugger
            if (find) {
              const data = (find.EnumList || []).find(d => d.Value === KeyEvent);

              if (data) {
                data.keyName = item.Name
                data.Icon = item.Icon
                data.HIcon = item.HIcon
                data.selectIndex = (this.sceneIconList || []).findIndex(item => item.Icon === data.Icon)
              }
            }
          })
        }
      } catch (e) {
        console.log('....获取已配置的按键列表', e)
      }
    },
    handlerIconClick(item, index) {
      item.selectIndex = index
      item.Icon = this.sceneIconList[index].Icon
      item.HIcon = this.sceneIconList[index].HIcon
      item.change = true
      this.isChange = true;
    },
    showAdd(item) {
      const { sceneList,max } = item
      if(max && sceneList && Array.isArray(sceneList)){
        return sceneList.length < max
      }
      return true
    },
    //获取触发器 trigger列表
    async getTriggerList() {
      try {
        if (this.TriggerList.length > 0) return
        const res = await FindTriggerAbility({
          VDeviceId: this.device.VDeviceId,
        })
        if (res.StatusCode == 0) {
          this.TriggerList = []
          ;(res.Result?.TriggerList || []).forEach(trigger => {
            ;(trigger.OperationType || []).forEach(operation => {
              this.TriggerList.push({
                ...trigger,
                OperationName: operation.Name,
                OperationValue: operation.Value,
                EnumValue: (trigger.EnumValue || []).map(item => ({
                  ...item,
                }))
              })
            })
          })
          this.TriggerList.forEach(item => {
            const { EnumValue, DefaultValue } = item
            if (EnumValue) {
              const find = EnumValue.find(_value => _value.Value == DefaultValue)
              if (find) {
                item.DefaultValue = find.Value
              }
            }
          })
          this.keyList = this.TriggerList.map((item, index) => {
            const { EnumValue } = item
            let EnumList = []
            if (EnumValue && Array.isArray(EnumValue)) {
              EnumList = EnumValue.map(_item => {
                return {
                  ..._item,
                  keyName: '',
                  Icon: '',
                  HIcon: '',
                  max: this.max,
                  tip: '(' + this.$t('ifttt.createUp3').replace(/\${{n}}/, this.max) + ')',
                  sceneList: [],
                }
              })
            }
            return {
              change: false, //是否修改过按键名称
              triggerInfo: item,
              Desc: item?.Desc,
              EnumList,
            }
          })

          this.getKeyEventList()
          this.getIFtttList()
        }
      } catch (e) {
        console.log('.....获取触发器列表errror', e)
      }
    },
    // 获取所有的绑定的自动化 && 匹配到按键
    async getIFtttList() {
      try {
        this.loading = true
        const res = await FindIFtttListByTrigger({
          vDeviceId: this.device.VDeviceId,
          ShowEntry: 1,
        })
        this.loading = false
        if (res.StatusCode == 0) {
          const Result = res?.Result || []
          this.clearScene()
          Result.forEach(info => {
            const { TriggerList } = info
            if (TriggerList) {
              TriggerList.forEach(trigg => {
                if (trigg.TriggerList) {
                  trigg.TriggerList.forEach(_tr => {
                    const { ExtraKeyId, KeyId, MsgId, Value1 } = _tr
                    const find = this.keyList.find(_list => {
                      const { triggerInfo } = _list
                      return triggerInfo.ExtraKeyId == ExtraKeyId && triggerInfo.KeyID == KeyId && triggerInfo.MsgID == MsgId
                    })
                    if (find) {
                      const { EnumList,triggerInfo } = find
                      if (EnumList && Array.isArray(EnumList)) {
                        const _find = EnumList.find(_emum => {
                          return _emum.Value == Value1
                        })
                        if (_find) {
                          _find?.sceneList.push({
                            IFT_ID: info?.IFT_ID,
                            IFT_Name: info?.IFT_Name,
                            info:{
                              ...info,
                              triggerName: _find.Name,
                              keyName: find.keyName,
                              triggerInfo: {
                                ...triggerInfo,
                                DefaultValue: _find.Value,

                              },
                            },
                          })
                        }
                      }
                    }
                  })
                }
              })
            }
          })
          this.$forceUpdate()
          console.log('....this.key',this.keyList)
        }
      } catch (e) {
        console.log('.....获取触发器列表errror', e)
      }
    },
    // 清空场景
    clearScene(){
      this.keyList.forEach(item => {
        item.EnumList.forEach(_item => {
          _item.sceneList = []
        })
      })
    },
    /**
     * 保存
     */
    async savesubmit() {
      try {
        if (!this.isChange) return

        const list = [];

        this.keyList.forEach(item => {
          item.EnumList.forEach(enumItem => {
            if (enumItem.change) {
              list.push({
                VDeviceId: this.device.VDeviceId,
                Name: enumItem.keyName,
                Icon: enumItem.Icon || '',
                HIcon: enumItem.HIcon || enumItem.Icon || '',
                Type: 1,
                MessageType: item?.triggerInfo?.MsgID ?? '',
                NameId: item?.triggerInfo?.PhyPosition ?? '',
                KeyEvent: enumItem.Value, // item?.triggerInfo?.DefaultValue ?? '',
              })
            }
          })
        })

        debugger

        const req = {
          DeviceSwitchKeyNames: list,
        }

        const res = await setSwitchKeyName(req)
        if (res.StatusCode == 0) {
          alertsuccess(this, res.StatusCode)
          this.keyList.forEach(item => {
            item.change = false
          })
          this.getKeyEventList()
        }
      } catch (error) {
        console.log('保存error', error)
      }
    },
    /**
     * 处理keylist
     */
    handleGpList() {
      try {
        this.getTriggerList()
      } catch (error) {
        console.log('.....errror', error)
      }
    },
    //修改按键名称
    changeInput(item) {
      this.isChange = true;
      item.change = true;
    },

    /**
     * 拼接字符串
     */
    handleUTF8(list) {
      try {
        let str = ''
        let all_length = 0
        list.forEach(item => {
          const { DeviceId, ClassSku, Mac, DeviceName } = item
          if (DeviceId) {
            const linkType = jsToUTF8(0, 1)
            let ProtocolType = ''
            if (item.ProtocolTypeList && Array.isArray(item.ProtocolTypeList) && item.ProtocolTypeList.length > 0) {
              ProtocolType = item.ProtocolTypeList[0]?.Id
              ProtocolType = jsToUTF8(+ProtocolType, 2)
            }
            const id = jsToUTF8(+DeviceId, 4)
            const classSku = jsToUTF8(ClassSku, 4, false, false)
            const mac = jsToUTF8(Mac, 6, false, false)
            let deviceType = ''
            if (item.DeviceTypeList && Array.isArray(item.DeviceTypeList) && item.DeviceTypeList.length > 0) {
              let SubList = item.DeviceTypeList[0]?.SubList
              if (SubList && Array.isArray(SubList) && SubList.length > 0) {
                deviceType = SubList[0]?.Id
                deviceType = jsToUTF8(+deviceType, 4)
              }
            }
            const { hexString, byteLength } = jsToUTF8(DeviceName, 21, true)
            const nameLength = jsToUTF8(+byteLength, 1)
            const name = hexString
            const str1 = linkType + ProtocolType + id + classSku + mac + deviceType + nameLength + name
            str += str1
            all_length += 22 + byteLength
          }
        })
        const all_length_str = jsToUTF8(all_length, 2)
        str = all_length_str + str
        return str
      } catch (error) {
        console.log('......error', error)
      }
    },
    onAddSence(item,triggerType) {
      this.showIfttDialog = true
      this.selectKey = item
      this.$nextTick(() => {
        this.$refs.EleIftttCustomSet.deviceOption = [
          {
            VDeviceId: this.device.VDeviceId,
            DeviceName: this.device.DeviceName,
            ChannelId: this.device.ChannelId,
            AreaName: this.device.AreaName,
            ClassSku: this.device.ClassSku,
            ChildId: this.device.ChildId,
            triggle: {
              ...item.triggerInfo,
              DefaultValue: triggerType?.Value,
            },
          },
        ]
      })
    },
    closeIfttDialog() {
      this.showIfttDialog = false
    },
    //编辑自动化
    async editIftt(item) {
      const res = await Find({ iftttNo: item?.IFT_ID })
      this.showIfttDialog = true
      this.selectKey = item
      this.$nextTick(() => {
        this.$refs.EleIftttCustomSet.iftttSetParamMake(res.Result)
        this.$refs.EleIftttCustomSet.deviceOption = [
          {
            VDeviceId: this.device.VDeviceId,
            DeviceName: this.device.DeviceName,
            ChannelId: this.device.ChannelId,
            AreaName: this.device.AreaName,
            ClassSku: this.device.ClassSku,
            ChildId: this.device.ChildId,
            triggle: item?.triggerInfo,
          },
        ]
      })
    },
    //删除自动化
    async delIftt(item) {
      this.loading = true
      const res = await Delete({ iftttNo: item?.IFT_ID })
      this.loading = false
      if (res.StatusCode == 0) {
        item.ifTT = null
        this.getIFtttList()
      } else {
        alerterror(this, res.StatusCode)
      }
    },
    //编辑自动化后回调
    async postEvent(item) {
      this.getIFtttList()
      if (this.selectKey && !this.selectKey.keyName) {
        const list = [
          {
            VDeviceId: this.device.VDeviceId,
            Name: item.IFtttName,
            Icon: '',
            HIcon: '',
            Type: 1,
            MessageType: this.selectKey?.triggerInfo?.MsgID ?? '',
            NameId: this.selectKey?.triggerInfo?.PhyPosition ?? '',
            KeyEvent: this.selectKey?.triggerInfo?.DefaultValue ?? '',
          },
        ]
        const req = {
          DeviceSwitchKeyNames: list,
        }
        const res = await setSwitchKeyName(req)
        if (res.StatusCode == 0) {
          this.getKeyEventList()
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.device-key-setting-v2 {
  .border_title {
    position: relative;
    text-indent: 10px;
    font-size: 16px;
    color: #111;

    &::after {
      width: 2px;
      background-color: #0046aa;
      bottom: 0;
      content: '';
      position: absolute;
      left: 0;
      height: 16px;
    }
  }
  .device-key-setting-container {
    display: flex;
    width: 100%;
    border: 1px solid #e0e3e6;
    flex-direction: column;
    box-sizing: border-box;
    position: relative;
    flex-direction: row;

    .device-key-setting-container-right {
      padding: 40px 17px 61px 40px;
      display: flex;
      flex-direction: column;
      flex: 1;
      .device-key-setting-item {
        width: 100%;
        display: flex;
        flex-direction: row;
        // justify-content: center;
        // align-items: center;
        padding: 0px 0px 15px 150px;
        box-sizing: border-box;
        border-bottom: 1px solid #e0e3e6;
        margin-bottom: 15px;
        .device-key-setting-item-title {
          font-weight: 400;
          font-size: 14px;
          color: #606266;
          line-height: 40px;
        }
        .device-key-setting-item-right {
          display: flex;
          flex-direction: row;
          min-height: 80px;
          // align-items: center;
          margin-left: 20px;
          flex-grow: 1;
        

          .scene_list {
            margin-left: 20px;
            flex: 1;
           
            .scene_list_item_header {
              display: flex;
              flex-direction: column;
              // margin-bottom: 10px;
            }
            .scene_list_item {
              flex-grow: 1;
            }
            .triggerType_header {
              flex-direction: row;
              align-items: center;
              margin-bottom: 10px;
              span {
                font-size: 16px;
              }
              .tip {
                margin: 0px 10px;
              }
              .addSence {
                float: right;
                cursor: pointer;
              }
            }
            .iftt_add_item {
              flex-direction: row;
              padding-left: 15px;
              justify-content: space-between;
              display: flex;
              flex-direction: row;
              align-items: center;
              span {
                font-size: 14px;
                line-height: 40px;
                color: black;
              }
              .iftt_delete {
                margin-left: 10px;
                cursor: pointer !important;
              }
              .iftt_edit {
                cursor: pointer !important;
              }
            }
          }
        }
      }
      .save-btn {
        bottom: 20px;
      }
      .mode {
        .mode-title {
          margin-right: 20px;
        }
      }

      .icon_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        img {
          width: 81px;
          height: 81px;
        }

        span {
          font-size: 11px;
          color: #000000;
          margin-top: 5px;
          display: inline-block;
          width: 81px;
          text-align: center;
        }
      }
      .screen-device {
        flex-direction: row;
        display: flex;
        padding-top: 40px;
        position: relative;
      }
      .device_delete {
        position: absolute;
        right: 40px;
        top: 10px;
        padding: 9px 15px;
        border: 1px solid #1b45a4;
        border-radius: 4px;
        color: #1b45a4;
      }
    }
  }
}
.el-popover-custom,
.opple-ability-ui-com-image-icon-enum_img {
  img {
    width: 36px;
    height: 36px;
  }
}

.opple-ability-ui-com-image-icon-enum_icon {
  position: relative;

  .edit {
    position: absolute;
    right: 0;
    top: 0px;
    width: 18px;
    height: 14px;
  }
}

.gray {
  opacity: 0.5;
  border: solid 1px #c6c6c6;
  color: #c6c6c6;
}

.gray:hover {
  cursor: not-allowed;
  border: solid 1px #c6c6c6;
  color: #c6c6c6;
  background: #fff;
}

.change {
  opacity: 1;
}
.device-key-setting-v2 ::v-deep .test {
  width: 1400px;
}
.device-key-setting-list-box {
  flex: 1;
}
</style>
